// Communicate with Sanity
import sanityClient from '@sanity/client'

export default sanityClient({
    projectId: '0bpi20mw',
    dataset: 'production'
})